import type { Board } from "../../board";
import { PRIORITY_DEFAULT, type ProcessableThing } from "../../interfaces";
import { Thing } from "../../thing";
import type { Weapon } from "../../weapon";

export class PlayerHasAmmoAction extends Thing implements ProcessableThing {
	static key = "PlayerHasAmmoAction";
	private weaponClass: new (...args: any[]) => Weapon;
	private action: () => void;

	constructor(weaponClass: new (...args: any[]) => Weapon, action: () => void = () => {}) {
		super();
		this.weaponClass = weaponClass;
		this.action = action;
	}

	processTurn(board: Board): void {
		if (!board.player) return;
		const ammo = this.getAmmo(board);
		if (ammo !== null && ammo > 0) {
			this.action();
			board.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	private getAmmo(board: Board): number | null {
		const weapon = board.player!.arsenal.getAllWeapons().find((w) => w instanceof this.weaponClass);
		if (!weapon) return null;
		return weapon.ammo;
	}

	static deserialize(_data: any): PlayerHasAmmoAction {
		// Actions with callbacks can't be fully deserialized — return a no-op placeholder
		return new PlayerHasAmmoAction(class extends (Object as any) {} as any);
	}
}
